const messages = {
  name: 'Prueba |||| Pruebas',
  sections: {
    accountApplication: 'Cuenta y aplicacion',
    message: 'Mensaje',
    attachments: 'Adjuntos',
    recipients: 'Destinatarios',
    scheduling: 'Programacion',
    delivery: 'Opciones de entrega',
    notification: 'Notificacion',
    customData: 'Datos personalizados',
    actions: 'Acciones',
  },

  fields: {
    account: 'Cuenta',
    application: 'Aplicacion',
    recipientType: 'Tipo de Destinatario',
    address: 'Direccion',
    number: 'Numero',
    chatId: 'ID de Chat',
    title: 'Titulo',
    type: 'Tipo',
    message: 'Mensaje',
    icon: 'Icono',
    badge: 'Insignia',
    tag: 'Etiqueta',
    requireInteraction: 'Requiere Interaccion',
    priority: 'Prioridad',
    action: 'Accion',
    dataKey: 'Clave',
    dataValue: 'Valor',
    groupId: 'ID de Grupo',
    messageType: 'Tipo de Mensaje',
    template: 'Plantilla',
    language: 'Idioma',
    variableKey: 'Clave',
    variableValue: 'Valor',
    subject: 'Asunto',
    content: 'Contenido',
    uploadAttachments: 'Subir Adjuntos',
    messagePriority: 'Prioridad del Mensaje',
    scheduleType: 'Tipo de Programacion',
    scheduleDate: 'Fecha de Programacion',
    scheduleTime: 'Hora de Programacion',
    intervalValue: 'Valor de Intervalo',
    intervalUnit: 'Unidad de Intervalo',
    expirationDate: 'Fecha de Expiracion',
    expirationTime: 'Hora de Expiracion',
    timezone: 'Zona Horaria',
    webhookUrl: 'Web Hook',
    whatsappMetaTemplate: 'Plantilla de WhatsApp (Meta)',
    whatsappTemplateSource: 'Origen de plantilla',
    whatsappMetaTemplateHintNoAccount: 'Selecciona una cuenta para cargar las plantillas.',
    whatsappMetaTemplateHintEmpty: 'No se encontraron plantillas para esta cuenta.',
    headerMediaTitle: 'Media de Cabecera de Plantilla',
    headerMediaSourceUrl: 'URL publica',
    headerMediaSourceUpload: 'Subir archivo',
    headerMediaUrl: 'URL del archivo',
    headerMediaFilename: 'Nombre del archivo (mostrado al destinatario)',
    headerMediaFilenameHint: 'Se envia como nombre del documento al destinatario.',
    headerMediaDropzone: 'Haz clic para elegir un archivo',
    headerMediaDropzoneHint: 'Se subira a Meta al enviar. Maximo %{max}.',
    headerMediaReady: 'listo para subir al enviar',
    customMediaTitle: 'Media (opcional)',
    customMediaType: 'Tipo de Media',
    customMediaTypeHint: 'Dejalo vacio para enviar un mensaje de texto simple.',
    customMediaCaptionHint: 'El contenido se enviara como pie de foto / video / documento.',
    customMediaAudioHint: 'Los mensajes de audio no admiten subtitulos — el contenido se ignorara.',
  },
  teamChat: {
    title: 'Formulario de prueba de Team Chat',
    destination: 'Destino',
    target: 'Plataforma',
    targetHelp: 'El formato Slack también sirve para Mattermost / Rocket.Chat',
    targetRequired: 'La plataforma es obligatoria',
    webhookUrlField: 'URL del incoming webhook',
    webhookUrlRequired: 'La URL del webhook es obligatoria',
    webhookUrlHttps: 'Debe ser una URL https://',
    titleField: 'Título',
    severity: 'Severidad',
    severityNone: 'Ninguna',
    textField: 'Texto',
    textRequired: 'El texto es obligatorio',
  },
  viber: { title: 'Formulario de prueba de Viber' },
  line: { title: 'Formulario de prueba de LINE' },
  botChat: {
    userId: 'User ID',
    userIdRequired: 'El user ID es obligatorio',
    textField: 'Texto',
    textRequired: 'El texto es obligatorio',
    viberUserIdHelp: 'User id de Viber de alguien que haya iniciado conversacion con el bot',
    lineUserIdHelp: 'User id de LINE (U…) de alguien que haya anadido la cuenta oficial',
  },
  inbox: {
    title: 'Formulario de prueba de Inbox',
    userIdHelp: 'Identificador de usuario del cliente (cualquier string)',
    linkField: 'Enlace (opcional)',
    viewSection: 'Buzon del primer usuario',
    viewButton: 'Ver buzon',
    markAllRead: 'Marcar todo leido',
    unread: '%{smart_count} sin leer',
  },
  webhook: {
    title: 'Formulario de prueba de Webhook',
    urlField: 'URL del endpoint',
    eventField: 'Evento',
    payloadSection: 'Payload',
    payloadField: 'Payload JSON',
    payloadHelp: 'Se entrega tal cual como body del POST',
    payloadRequired: 'El payload es obligatorio',
    payloadInvalid: 'El payload no es JSON valido',
    secretField: 'Secreto de firma (opcional)',
    secretHelp: 'Si se indica, las entregas llevan X-Notify-Signature (HMAC-SHA256)',
  },
  submenu: {
    email: 'Email',
    sms: 'SMS',
    whatsapp: 'WHATSAPP',
    telegram: 'Telegram',
    webPush: 'Web Push',
    appPush: 'App Push',
    teamChat: 'Team chat',
    viber: 'Viber',
    line: 'LINE',
    inbox: 'Inbox',
    webhook: 'Webhook',
  },
  choices: {
    recipientType: {
      INDIVIDUAL: 'INDIVIDUAL',
      GROUP: 'GROUP',
    },
    messageType: {
      TEMPLATE: 'TEMPLATE',
      CUSTOM: 'CUSTOM',
    },
    messagePriority: {
      CRITICAL: 'CRITICAL',
      STANDARD: 'STANDARD',
    },
    scheduleType: {
      NONE: 'NONE',
      ONCE: 'ONCE',
      RECURRING: 'RECURRING',
    },
    intervalUnit: {
      MINUTE: 'MINUTE',
      HOUR: 'HOUR',
      DAY: 'DAY',
      WEEK: 'WEEK',
      MONTH: 'MONTH',
      YEAR: 'YEAR',
    },
    headerMediaType: {
      IMAGE: 'IMAGE',
      DOCUMENT: 'DOCUMENT',
      VIDEO: 'VIDEO',
      AUDIO: 'AUDIO',
    },
    customMediaType: {
      NONE: 'Ninguno',
    },
  },
  email: { title: 'Formulario de Prueba de Email' },
  sms: { title: 'Formulario de Prueba de SMS' },
  whatsapp: { title: 'Formulario de Prueba de Whatsapp' },
  telegram: { title: 'Formulario de Prueba de Telegram' },
  webPush: { title: 'Formulario de Prueba de Web Push' },
  appPush: { title: 'Formulario de Prueba de App Push' },
  actions: {
    addAddresses: 'Anadir Direcciones',
    addNumbers: 'Anadir Numeros',
    addChatIds: 'Anadir ID de Chat',
    addVariable: 'Anadir Variable',
    addData: 'Anadir Datos',
    addActions: 'Anadir Acciones',
    addAttachment: '+ Anadir Adjunto',
    headerMediaChooseFile: 'Elegir archivo',
    cancel: 'Cancelar',
    submit: 'Enviar',
    sendTest: 'Enviar prueba',
    addAttachmentOrImage: 'Anadir adjunto o imagen inline',
  },
  attachments: {
    chooseFile: 'Elegir archivo',
    embedInline: 'Incrustar en el cuerpo del email (CID)',
    contentId: 'Content ID',
    contentIdHelper: 'Referenciar en HTML como <img src="cid:LOGO"/>',
    nonImageInlineWarning:
      'Los adjuntos en linea suelen ser imagenes. Otros tipos MIME pueden no mostrarse correctamente.',
    errorUnsupportedType:
      'Solo se admiten archivos PDF, de imagen o de texto plano.',
    noAttachments: 'Sin adjuntos. Haz clic en "+ Anadir Adjunto" para agregar uno.',
    insertImage: {
      title: 'Insertar imagen',
      fileLabel: 'Archivo de imagen',
      fileHelper: 'PNG / JPG / GIF hasta 5MB',
      width: 'Ancho (px)',
      height: 'Alto (px)',
      errorFileRequired: 'Selecciona un archivo de imagen',
      errorNotImage: 'El archivo debe ser una imagen',
      errorTooLarge: 'La imagen debe ser de 5MB o menos',
      insertButton: 'Insertar',
    },
    attachFile: {
      title: 'Adjuntar archivo',
      fileLabel: 'Archivo',
      fileHelper: 'PDF, imagen o texto plano hasta 5MB',
      attachButton: 'Adjuntar',
    },
    preview: {
      heading: '%{smart_count} adjunto |||| %{smart_count} adjuntos',
    },
  },
  editor: {
    bold: 'Negrita',
    italic: 'Cursiva',
    bulletList: 'Lista con vinetas',
    orderedList: 'Lista numerada',
    insertImage: 'Insertar imagen',
    attachFile: 'Adjuntar archivo',
    undo: 'Deshacer',
    redo: 'Rehacer',
  },
  validation: {
    accountRequired: 'La cuenta es obligatoria',
    applicationRequired: 'La aplicacion es obligatoria',
    recipientTypeRequired: 'El tipo de destinatario es obligatorio',
    groupRequired: 'El grupo es obligatorio',
    numberRequired: 'El numero es obligatorio',
    chatIdRequired: 'El ID de chat es obligatorio',
    addressRequired: 'La direccion es obligatoria',
    messageTypeRequired: 'El tipo de mensaje es obligatorio',
    templateRequired: 'La plantilla es obligatoria',
    contentRequired: 'El contenido es obligatorio',
    messagePriorityRequired: 'La prioridad del mensaje es obligatoria',
    typeRequired: 'El tipo es obligatorio',
    titleRequired: 'El titulo es obligatorio',
    messageRequired: 'El mensaje es obligatorio',
    iconRequired: 'El icono es obligatorio',
    badgeRequired: 'La insignia es obligatoria',
    tagRequired: 'La etiqueta es obligatoria',
    priorityRequired: 'La prioridad es obligatoria',
    contentIdRequired: 'El Content ID es obligatorio para adjuntos en linea',
    contentIdInvalidChars:
      'El Content ID solo puede contener letras, digitos, guiones bajos, guiones y puntos',
    contentIdDuplicate: 'El Content ID debe ser unico entre los adjuntos',
    headerMediaUrlRequired: 'La URL del archivo es obligatoria',
    headerMediaUrlInvalid: 'Introduce una URL http(s) valida',
    headerMediaTooLarge: 'El archivo supera el limite de %{max}',
    headerMediaReadFailed: 'Error al leer el archivo',
    headerMediaFilenameRequired: 'El nombre del archivo es obligatorio para documentos',
  },
  notifications: {
    emailSent: 'Email enviado correctamente',
    smsSent: 'SMS enviado correctamente',
    whatsappSent: 'Mensaje de Whatsapp enviado correctamente',
    telegramSent: 'Telegram enviado correctamente',
    teamChatSent: 'Mensaje de team chat publicado correctamente',
    viberSent: 'Viber enviado correctamente',
    lineSent: 'LINE enviado correctamente',
    inboxSent: 'Mensaje guardado en el buzon',
    webhookSent: 'Webhook entregado correctamente',
    webPushSent: 'Notificacion Web enviada correctamente',
    appPushSent: 'Notificacion Push enviada correctamente',
    emailSendFailed: 'Error al enviar el email',
    smsSendFailed: 'Error al enviar el SMS',
    whatsappSendFailed: 'Error al enviar el mensaje de Whatsapp',
    telegramSendFailed: 'Error al enviar el mensaje de Telegram',
    teamChatSendFailed: 'No se pudo publicar el mensaje de team chat',
    viberSendFailed: 'No se pudo enviar el mensaje de Viber',
    lineSendFailed: 'No se pudo enviar el mensaje de LINE',
    inboxSendFailed: 'No se pudo guardar el mensaje',
    webhookSendFailed: 'No se pudo entregar el webhook',
    inboxLoadFailed: 'No se pudo cargar el buzon',
    webPushSendFailed: 'Error al enviar la Notificacion Web',
    appPushSendFailed: 'Error al enviar la Notificacion Push',
    loadAccountsFailed: 'Error al cargar las cuentas',
    attachmentReadFailed: 'Error al leer el adjunto',
  },
};

export default messages;
